<template>
<div
	class="payment-information"
	:class="{ 'hidden': paymentMethods.length <= 1 }">
	<div class="payment-information-header section-title">
		<span :style="getStyle(node)">Metode Pembayaran:</span>
	</div>
	<div class="ooef-payment-options" v-if="paymentMethods.length > 0">
		<div class="ooef-payment-option" v-for="(payment, index) in paymentMethods" :key="index">
			<div class="ooef-payment-option-title">
				<label class="custom-control custom-radio">
					<input
						type="radio"
						name="ooef_payment_method"
						class="ooef-payment-method custom-control-input"
						:value="payment"
						v-model="selected"
					/>
					<div class="custom-control-label">
						<img :src="`https://cdn.orderonline.id/icons/${payment.img_name}.png`" :alt="payment.key">
						<span>
							{{ payment.label }}
						</span>
					</div>
				</label>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import {
	paymentOptions,
	// eslint-disable-next-line
	paymentChannels,
} from '@/lib/statics';
import {
	getNodeStyle,
} from '@/lib/helper';

// eslint-disable-next-line
const mapOrder = (array, order, key) => {
	array.sort((a, b) => {
		const A = a[key]; const
			B = b[key];

		if (order.indexOf(A) > order.indexOf(B)) {
			return 1;
		}
		return -1;
	});

	return array;
};

// eslint-disable-next-line
const insertArray = (arr, index, newItem) => [
	// part of the array before the specified index
	...arr.slice(0, index),
	// inserted item
	newItem,
	// part of the array after the specified index
	...arr.slice(index),
];


// const paymentMethods = []
export default {
	name: 'Payment',
	props: {
		node: Object,
		payments: {
			type: Array,
			default: () => [],
		},
		paymentChannels: {
			type: Array,
			default: () => [],
		},
		selectedPayment: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			isFetching: false,
			paymentMethods: [],
		};
	},
	computed: {
		selected: {
			get() {
				return this.selectedPayment;
			},
			set(value) {
				this.$emit('select', value);
			},
		},
	},
	watch: {},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.setPaymentMethods();
		},
		setPaymentMethods() {
			// eslint-disable-next-line
			// let payments = paymentOptions.filter(({ key }) => this.payments.includes(key));
			let payments = this.payments.map((curr) => {
				const payment = paymentOptions.find(({ key }) => key === curr);
				payment.img_name = `payment-${curr}`;
				payment.method = curr;
				payment.channels = [];
				return payment;
			});

			const hasInstantPayment = payments.findIndex(({ key }) => key === 'instant') !== -1;
			if (hasInstantPayment) {
				// remove instant payment from object
				payments = payments.filter(curr => curr.key !== 'instant');
				// set payment channel
				const paymentChannelOptions = this.paymentChannels.map((curr) => {
					const paymentChannel = paymentChannels.find(({ key }) => key === curr);
					paymentChannel.img_name = `payment-channel-${curr}`;
					paymentChannel.method = 'instant';
					paymentChannel.channels = [];
					return paymentChannel;
				});

				paymentChannelOptions.reverse();

				// merge payment methods with payment instant
				const instantIndex = this.payments.findIndex(curr => curr === 'instant');
				for (let i = 0; i < paymentChannelOptions.length; i++) {
					const element = paymentChannelOptions[i];
					payments = insertArray(payments, instantIndex, element);
				}
			}
			this.paymentMethods = payments;
			this.$emit('select', payments[0]);
		},
		onSelect(value) {
			console.log('value: ', value);
		},
		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>

<style class="scss" scoped>
.text-small {
	font-size: 10px;
}
</style>
